export async function fetchTokenPriceDefined(token, network) {
    const response = await fetch('https://graph.defined.fi/graphql', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: '44aec9191920ac623b5ec254ed50b13d68600a20',
        },
        body: JSON.stringify({
            query: `{
          getTokenPrices(
            inputs: [
              { address: "${token}", networkId: ${parseInt(network)} }
            ]
          ) {
            address
            networkId
            priceUsd
          }
        }`,
        }),
    });
    const data = await response.json();
    return data;
}
